import { NavItem } from "./types/navigation"

const NavigationData: NavItem[] = [
  {
    name: "Solutions",
    intro: {
      heading: "Solutions",
      copy: "Move, manage and tokenize value with Ripple’s crypto and blockchain solutions.",
    },
    sections: [
      {
        links: [
          {
            linkTo: "/solutions/cross-border-payments/",
            heading: "Payments",
            subheading: "Send instant payments",
          },
          {
            linkTo: "/solutions/digital-asset-custody/",
            heading: "Custody",
            subheading: "Access digital assets",
          },
          {
            linkTo: "/solutions/stablecoin/",
            heading: "Stablecoin",
            subheading: "Transact with confidence",
          },
        ],
      },
      {
        heading: "Use Cases",
        links: [
          {
            linkTo: "/use-case/banks/",
            heading: "Banks",
          },
          {
            linkTo: "/use-case/fintechs/",
            heading: "Fintechs",
          },
          {
            linkTo: "/use-case/psp/",
            heading: "Payment Service Providers",
          },
          {
            linkTo: "/use-case/crypto-businesses/",
            heading: "Crypto Businesses",
          },
        ],
      },
    ],
  },
  {
    name: "Customers",
    intro: {
      heading: "Customers",
      copy: "Read stories from our global customer base.",
    },
    sections: [
      {
        links: [
          {
            linkTo: "/customers/",
            heading: "Customer Overview",
          },
          {
            linkTo: "/customer-case-study/",
            heading: "Customer Case Studies",
          },
        ],
      },
      {
        heading: "Featured Customers",
        links: [
          {
            linkTo: "/customer-case-study/travelex-bank/",
            heading: "Travelex Bank",
            subheading: "Accessing new markets",
          },
          {
            linkTo: "/customer-case-study/instarem/",
            heading: "Instarem",
            subheading: "Streamlining internal treasury",
          },
          {
            linkTo: "/customer-case-study/flash-payments/",
            heading: "Flash Payments",
            subheading: "Accelerating global expansion",
          },
        ],
      },
    ],
  },
  {
    name: "Resources",
    intro: {
      heading: "Resources",
      copy: "Dive into crypto with the latest thought leadership, industry events and more.",
    },
    sections: [
      {
        links: [
          {
            linkTo: "/insights/",
            heading: "Blog",
          },
          {
            linkTo: "/content-library/",
            heading: "Content Library",
          },
          {
            linkTo: "/events/",
            heading: "Events",
          },
          {
            linkTo: "/xrp/",
            heading: "About XRP",
          },
          {
            linkTo: "/faq/",
            heading: "FAQs",
          },
        ],
      },
      {
        heading: "Developers",
        links: [
          {
            linkTo: "https://docs.ripple.com/",
            heading: "Ripple Product Docs",
            outbound: true,
          },
          {
            linkTo: "https://xrpl.org/docs",
            heading: "XRP Ledger Docs",
            outbound: true,
          },
        ],
      },
    ],
  },
  {
    name: "Company",
    intro: {
      heading: "About Us",
      copy: "Learn how we’re transforming global finance",
    },
    sections: [
      {
        links: [
          {
            linkTo: "/company/",
            heading: "About Us",
          },
          {
            linkTo: "/company/leadership/",
            heading: "Leadership",
          },
          {
            linkTo: "/public-policy/",
            heading: "Public Policy",
          },
          {
            linkTo: "/investments/",
            heading: "Investments",
          },
          {
            linkTo: "/impact/",
            heading: "Ripple Impact",
          },
        ],
      },
      {
        heading: "RIPPLE CAREERS",
        links: [
          {
            linkTo: "/careers/",
            heading: "Careers Overview",
          },
          {
            linkTo: "/careers/all-jobs/",
            heading: "Open Roles",
          },
        ],
      },
    ],
  },
]

export default NavigationData
